import { createContext } from "react";
import { useReducer } from "reinspect";
// import IEvent, { IAttendeeCategory } from "../dataProvider/interfaces/IEvent";
// import ISessionReservation from "../dataProvider/interfaces/ISessionReservation";
// import ISessionLocation from "../dataProvider/interfaces/ISessionLocation";
// import IUser from "../dataProvider/interfaces/IUser";
import Reducer from "./Reducer";
// INITIAL STATE
import { initCategoriesList } from "../helpers/constants";

// interface IState {
//   selectedEvent: IEvent | null;
//   eventsList: IEvent[] | null;
//   attendeeCategoriesList: IAttendeeCategory[] | null;
//   currentUser: null | IUser;
//   sessionLocations: null | ISessionLocation[];
//   sessionReservations: null | ISessionReservation[];
// }

const initialState: any = {
  selectedEvent: null,
  eventsList: null, // it will contain only the fetched active events (not all the events)
  attendeeCategoriesList: initCategoriesList, // the attendee categories for the selected event
  currentUser: null,
  sessionLocations: null,
  sessionReservations: null,
  alertList: null,
  selectedAlert: null,
  selectedReservationItems: null,
  selectedReserveToDelete: null,
  hasLead:false,
  leadsData:{loading:true,leadsInfo:false},
};

const Store = ({ children }: { children: any }) => {
  const [state, dispatch] = useReducer(
    Reducer,
    initialState,
    (a) => a,
    "context_store"
  );
  return (
    <StoreContext.Provider value={[state, dispatch]}>
      {children}
    </StoreContext.Provider>
  );
};

export const StoreContext = createContext(initialState);
export default Store;
